__turbopack_context__.v({
  "deleteButton": "styles-module-scss-module__AwtZ5q__deleteButton",
  "dropDown": "styles-module-scss-module__AwtZ5q__dropDown",
  "filterNameInput": "styles-module-scss-module__AwtZ5q__filterNameInput",
  "noSaved": "styles-module-scss-module__AwtZ5q__noSaved",
  "notice": "styles-module-scss-module__AwtZ5q__notice",
  "noticeError": "styles-module-scss-module__AwtZ5q__noticeError",
  "notificationLink": "styles-module-scss-module__AwtZ5q__notificationLink",
  "optionCheck": "styles-module-scss-module__AwtZ5q__optionCheck",
  "optionLabel": "styles-module-scss-module__AwtZ5q__optionLabel",
  "saveFilterButton": "styles-module-scss-module__AwtZ5q__saveFilterButton",
  "saveFilters": "styles-module-scss-module__AwtZ5q__saveFilters",
  "saveState": "styles-module-scss-module__AwtZ5q__saveState",
  "saveStateActive": "styles-module-scss-module__AwtZ5q__saveStateActive",
  "saveStateButton": "styles-module-scss-module__AwtZ5q__saveStateButton",
  "savedIcon": "styles-module-scss-module__AwtZ5q__savedIcon",
  "savedOption": "styles-module-scss-module__AwtZ5q__savedOption",
  "savedOptionTitle": "styles-module-scss-module__AwtZ5q__savedOptionTitle",
  "shareButton": "styles-module-scss-module__AwtZ5q__shareButton",
  "signInFlash": "styles-module-scss-module__AwtZ5q__signInFlash",
  "title": "styles-module-scss-module__AwtZ5q__title",
  "titleContainer": "styles-module-scss-module__AwtZ5q__titleContainer",
  "titleText": "styles-module-scss-module__AwtZ5q__titleText",
});
